import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { useWatch } from "react-hook-form";
import CustomTextInput from "../../components/CustomTextInput";

export const DOCUMENT_NOTE_MAX_LENGTH = 1000;
export const DOCUMENT_NOTE_SPECIAL_CHAR_MESSAGE =
  "Note must not contain special characters";

const NOTE_PLACEHOLDER =
  "Optional. Maximum 1000 characters; letters, numbers and spaces only.";

export function isAllowedDocumentNote(value) {
  if (value == null || value === "") {
    return true;
  }

  return /^[\p{L}\p{N}\s]*$/u.test(value);
}

/**
 * Document-level Note (IBT-022) — placed at the bottom of invoice/credit-note forms.
 */
export default function DocumentNoteField({ control, errors, readOnly }) {
  const noteValue = useWatch({ control, name: "note" }) || "";
  const length = typeof noteValue === "string" ? noteValue.length : 0;
  const isEmpty = !noteValue || String(noteValue).trim() === "";

  if (readOnly && isEmpty) {
    return null;
  }

  return (
    <Box sx={{ mt: 3 }} data-testid="document-note-section">
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ mb: 1 }}
      >
        <Typography variant="subtitle1" fontWeight={700}>
          Note
        </Typography>
        {!readOnly && (
          <Typography variant="body2" color="text.secondary">
            {length}/{DOCUMENT_NOTE_MAX_LENGTH} characters
          </Typography>
        )}
      </Stack>
      <CustomTextInput
        name="note"
        control={control}
        errors={errors}
        readOnly={readOnly}
        multiline
        minRows={3}
        maxRows={8}
        placeholder={readOnly ? undefined : NOTE_PLACEHOLDER}
        inputProps={{
          maxLength: DOCUMENT_NOTE_MAX_LENGTH,
          "data-testid": "note-input",
        }}
        sx={
          readOnly
            ? {
                "& .MuiInputBase-input": {
                  whiteSpace: "pre-wrap",
                },
              }
            : undefined
        }
      />
    </Box>
  );
}
